import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-pdfviewerpage',
  templateUrl: './pdfviewerpage.component.html',
  styleUrls: ['./pdfviewerpage.component.scss']
})
export class PdfviewerpageComponent implements OnInit {
  src = "/assets/pdf/termandcondition.pdf"; 
  constructor(
    public dialogRef: MatDialogRef<PdfviewerpageComponent>
  ) { 
    let imagepath = '/assets/pdf/termandcondition.pdf'
   
  }

  ngOnInit() {
    
  //  this.src = "/assets/pdf/termandcondition.pdf"; 
   this.pdfview(true);
  }
  pdfview(refresh){
    this.src = "/assets/pdf/termandcondition.pdf"; 

  }

  onCancel() {
    this.dialogRef.close();
  }
}
